import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { DefaultProviders } from "./components/providers/default";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import AppBlocchain from "./blockchain/App";
export default function App() {

  useEffect(() => {
    // Remove dark mode class if present
    document.documentElement.classList.remove("dark");

    // Remove inline color-scheme if present
    document.documentElement.style.removeProperty("color-scheme");

    // Add your default light mode class
    document.documentElement.classList.add("light", "root");
  }, []); // empty dependency = run once on mount


  return (
    <DefaultProviders>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/blockchain" element={<AppBlocchain />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </DefaultProviders>
  );
}
